<div
  [attr.data-testId]="'display-' + context.column.header.name + '-' + context.row.index"
  class="mandatoryTextContainer"
>
  <span class="mandatory">*</span>
</div>
